// switch state dropdown icon between 'x' and down arrow
export function dropdownarrowstate() {
    let imagepath = require.context('@/assets/img/icons/', false, /\.png$/)
    let val = (this.state == "Select a State") ? 'dArrow32.png' : 'close-icon.png'
    return imagepath('./' + val)
}

// switch month dropdown icon between 'x' and down arrow
export function dropdownarrowmonth() {
    let imagepath = require.context('@/assets/img/icons/', false, /\.png$/)
    let val = (this.month == 'Any Month') ? 'dArrow32.png' : 'close-icon.png'
    return imagepath('./' + val)
}

// switch card dropdown icon between 'x' and down arrow
export function dropdownarrowcard() {
    let imagepath = require.context('@/assets/img/icons/', false, /\.png$/)
    let val = (this.card == 'Any Produce') ? 'dArrow32.png' : 'close-icon.png'
    return imagepath('./' + val)
}